import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from './icon.component';

/** Quantity stepper (− value +). */
@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="display:inline-flex;align-items:center;border-radius:11px;background:var(--fr-surface);
             box-shadow:inset 0 0 0 1.5px var(--fr-border-2)">
      <button (click)="dec()" [disabled]="value <= min"
        [style.width.px]="s.w" [style.height.px]="s.h"
        [style.color]="value <= min ? 'var(--fr-text-3)' : tone"
        style="border:none;cursor:pointer;background:transparent;display:flex;align-items:center;justify-content:center">
        <app-icon name="solar:minus-circle-linear" [size]="s.fs + 3"></app-icon>
      </button>
      <span class="fr-num" [style.font-size.px]="s.fs"
        style="min-width:22px;text-align:center;font-weight:750">{{ value }}</span>
      <button (click)="inc()" [disabled]="value >= max"
        [style.width.px]="s.w" [style.height.px]="s.h"
        [style.color]="value >= max ? 'var(--fr-text-3)' : tone"
        style="border:none;cursor:pointer;background:transparent;display:flex;align-items:center;justify-content:center">
        <app-icon name="solar:add-circle-linear" [size]="s.fs + 3"></app-icon>
      </button>
    </div>`,
})
export class StepperComponent {
  @Input() value = 0;
  @Input() min = 0;
  @Input() max = 99;
  @Input() size: 'sm' | 'md' = 'md';
  @Input() accent?: string;
  @Output() valueChange = new EventEmitter<number>();

  get s() { return this.size === 'sm' ? { h: 32, w: 30, fs: 14 } : { h: 40, w: 38, fs: 16 }; }
  get tone(): string { return this.accent || 'var(--brand)'; }

  dec(): void { if (this.value > this.min) this.valueChange.emit(this.value - 1); }
  inc(): void { if (this.value < this.max) this.valueChange.emit(this.value + 1); }
}
